import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactContext = createContext();

export const ContactProvider = ({ children }) => {
  const [contactSettings, setContactSettings] = useState({
    phone_primary: '+91 99999 99999',
    phone_secondary: '',
    email_primary: 'info@urbancial.com',
    email_secondary: '',
    whatsapp_number: '+919999999999',
    address_line1: 'Golf Course Road, Sector 54',
    address_line2: 'Gurugram, Haryana 122002',
    working_hours_weekday: 'Mon - Sat: 10:00 AM - 7:00 PM',
    working_hours_weekend: 'Sunday: Closed',
    google_maps_url: '',
    facebook_url: '',
    instagram_url: '',
    linkedin_url: '',
    twitter_url: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings/contact`);
        setContactSettings(response.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  return (
    <ContactContext.Provider value={{ contactSettings, loading }}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContact = () => {
  const context = useContext(ContactContext);
  if (!context) {
    throw new Error('useContact must be used within a ContactProvider');
  }
  return context;
};

export default ContactContext;
